/**
 * Referral link capture — stores ?ref=CODE in localStorage on first visit,
 * so it survives the OAuth roundtrip and can be sent to /api/auth/session.
 */
const KEY = "pending_referral_code";
const MAX_AGE_DAYS = 30;

export const REFERRAL_STORAGE_KEY = KEY;

export const captureReferralFromUrl = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get("ref");
    if (!raw) return;
    const code = raw.trim().toUpperCase().slice(0, 16);
    if (!/^[A-Z0-9]{4,16}$/.test(code)) return;
    localStorage.setItem(
      KEY,
      JSON.stringify({ code, ts: Date.now() })
    );
    // Clean URL so the ref param doesn't leak into subsequent nav/share
    params.delete("ref");
    const qs = params.toString();
    const newUrl =
      window.location.pathname + (qs ? `?${qs}` : "") + window.location.hash;
    window.history.replaceState({}, "", newUrl);
  } catch {
    /* localStorage unavailable — silently skip */
  }
};

export const getPendingReferralCode = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { code, ts } = JSON.parse(raw);
    if (!code) return null;
    if (Date.now() - ts > MAX_AGE_DAYS * 24 * 60 * 60 * 1000) {
      localStorage.removeItem(KEY);
      return null;
    }
    return code;
  } catch {
    return null;
  }
};

export const clearPendingReferralCode = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
};
